import { createMuiTheme } from '@material-ui/core/styles';

export const theme = createMuiTheme({
    typography: {
        fontFamily: [
            'Quicksand',
            'sans-serif'
        ].join(','),
    },
    // spacing: [5, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
    props: {
        MuiContainer: {
            maxWidth: false
        }
    }
});

theme.overrides = {
    MuiContainer: {
        root: {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            [theme.breakpoints.up('xs')]: {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
            },
        },
        maxWidthMd: {
            maxWidth: "740px",
            [theme.breakpoints.up('xs')]: {
                maxWidth: "740px",
            },
        },
    },
};